import React from 'react';

import styles from './troy.module.scss';

import UserInfoItem from '.';

const TroyUserInfoItem = ({ children, type, onSubmit, initialValues }) => (
  <UserInfoItem {...{ styles, children, type, onSubmit, initialValues }} />
);

TroyUserInfoItem.propTypes = {};

export default TroyUserInfoItem;
